import { TextToVoiceIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import TTVButton from './IconButton';

const TextToVoiceToggle = ({
  isSelected,
  disabled = false,
  tooltip = 'Text to Voice',
  onClick = () => {},
}) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <div data-name="text-to-voice-toggle">
      <TTVButton
        grow={false}
        btnType="secondary"
        noMargin
        onClick={handleClick}
        selected={isSelected}
        disabled={disabled}
        dataName="transcript-ttv-button"
        tooltip={tooltip}
      >
        <Box as="span">
          <TextToVoiceIcon height={14} width={14} />
        </Box>
      </TTVButton>
    </div>
  );
};

export default TextToVoiceToggle;
